const FileFailedDropdownSkeleton = () => {
	return (
		<div className='dummy-skelton failedDropSkeleton h-100'>
			<div className='box p-0'>
				<div className='skeleton p-0'>
					<div className='skeleton-left flex1 p-0'>
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
						<div className='line product-line' />
					</div>
				</div>
			</div>
		</div>
	);
};

export default FileFailedDropdownSkeleton;
